import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyResponse, SurveyOption } from '@nx-c4g/c4g-models';
import { BaseSurveyStepComponent } from '../base-survey-step/base-survey-step.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'c4g-multiple-choice-multi-select-survey-step',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './multiple-choice-multi-select-survey-step.component.html',
  styleUrls: ['./multiple-choice-multi-select-survey-step.component.scss']
})
export class MultipleChoiceMultiSelectSurveyStepComponent extends BaseSurveyStepComponent {
  selectedOptionIds: string[] = [];
  currentPage = 0;
  readonly pageSize = 4;

  constructor(
    @Inject('stepData') stepData: any,
    @Inject('stepResponse') stepResponse: any,
    @Inject('initialStepResponse') initialStepResponse: any,
    public translate: TranslateService
  ) {
    super(stepData, stepResponse, initialStepResponse);
  }

  override ngOnInit() {
    super.ngOnInit();
    // Optionally initialize from initialStepResponse
    if (this.initialStepResponse && this.initialStepResponse.response) {
      this.selectedOptionIds = this.initialStepResponse.response.map((r: any) => r._id);
    }
  }

  get pagedOptions(): SurveyOption[] {
    const start = this.currentPage * this.pageSize;
    return this.stepData?.options?.slice(start, start + this.pageSize) || [];
  }

  get allOptionsShown(): boolean {
    return (this.currentPage + 1) * this.pageSize >= (this.stepData?.options?.length || 0);
  }

  onToggleOption(option: SurveyOption) {
    const idx = this.selectedOptionIds.indexOf(option._id);
    if (idx > -1) {
      this.selectedOptionIds.splice(idx, 1);
    } else {
      this.selectedOptionIds.push(option._id);
    }
  }

  onSeeMore() {
    if (!this.allOptionsShown) {
      this.currentPage++;
    }
  }

  override isValid(): boolean {
    // At least one selected, and all options have been shown
    return this.selectedOptionIds.length > 0 && this.allOptionsShown;
  }

  override async getResponse(): Promise<SurveyResponse | undefined> {
    if (!this.isValid()) return undefined;
    const selectedOptions = (this.stepData?.options || []).filter((opt: SurveyOption) => this.selectedOptionIds.includes(opt._id));
    return {
      stepId: this.stepData._id,
      showValueInReport: false,
      response: selectedOptions.map(opt => ({
        _id: opt._id,
        values: [opt.value]
      }))
    };
  }

  getLangValue(mls: { en: string; fr: string }): string {
    const lang = this.translate.currentLang === 'fr' ? 'fr' : 'en';
    return mls?.[lang] || mls?.['en'] || '';
  }

  getSeeMoreLabel(): string {
    return this.translate.instant('More');
  }
}
